import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=8d49d7ce&scoped=true"
import script from "./ListSkeleton.vue?vue&type=script&lang=js"
export * from "./ListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=8d49d7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d49d7ce",
  null
  
)

export default component.exports